import React from 'react';
import PropTypes from 'prop-types';

const ConfigurableStar = ({
    width = 24,
    height = 23,
    strokeUnfilled = '#90A0B7',
    stroke = '#54D2C3',
    strokeWidth = 1.6,
    fill = 'none',
    filled = false
}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 18 17">
        <path
            fill={filled ? stroke : fill}
            fillRule="evenodd"
            stroke={filled ? stroke : strokeUnfilled}
            strokeWidth={strokeWidth}
            d="M8.844 2l-2.11 4.28L2 6.972l3.43 3.33L4.61 15l4.235-2.22L13.08 15l-.822-4.698 3.43-3.33-4.734-.692z"
        />
    </svg>
);

ConfigurableStar.propTypes = {
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    stroke: PropTypes.string,
    strokeWidth: PropTypes.number,
    fill: PropTypes.string
};

export default ConfigurableStar;



// WEBPACK FOOTER //
// ./components/configurable_star/index.js